document.addEventListener("DOMContentLoaded", function () {
  const floating = document.getElementById("floating-video");
  const player = document.getElementById("floatingVideo");
  const closeBtn = document.getElementById("close-video");
  const fullBtn = document.getElementById("fullscreen-video");

  if (!floating || !player) return;

  // Close
  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      floating.style.display = "none";
    });
  }

  // Fullscreen
  if (fullBtn) {
    fullBtn.addEventListener("click", function (e) {
      e.stopPropagation();

      if (player.requestFullscreen) {
        player.requestFullscreen();
      } else if (player.webkitEnterFullscreen) {
        player.webkitEnterFullscreen();
      } else if (player.webkitRequestFullscreen) {
        player.webkitRequestFullscreen();
      }
    });
  }

  // Drag + snap
  let startX = 0;
  let startY = 0;
  let initialX = 0;
  let initialY = 0;
  let dragging = false;

  const GAP = 6; // smaller gap from edge after snapping

  function snapToNearestEdge() {
    const rect = floating.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Keep inside screen vertically
    const maxTop = viewportHeight - rect.height - GAP;
    let top = Math.max(GAP, Math.min(rect.top, maxTop));

    // Snap horizontally to the nearest side
    const distanceToLeft = rect.left;
    const distanceToRight = viewportWidth - rect.right;

    if (distanceToLeft <= distanceToRight) {
      floating.style.left = GAP + "px";
      floating.style.right = "auto";
    } else {
      floating.style.right = GAP + "px";
      floating.style.left = "auto";
    }

    floating.style.top = top + "px";
    floating.style.bottom = "auto";
  }

  floating.addEventListener(
    "touchstart",
    function (e) {
      if (e.target === closeBtn || e.target === fullBtn) return;

      dragging = true;

      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;

      const rect = floating.getBoundingClientRect();
      initialX = rect.left;
      initialY = rect.top;

      floating.style.left = initialX + "px";
      floating.style.top = initialY + "px";
      floating.style.right = "auto";
      floating.style.bottom = "auto";
    },
    { passive: true }
  );

  document.addEventListener(
    "touchmove",
    function (e) {
      if (!dragging) return;

      e.preventDefault();

      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;

      floating.style.left = initialX + dx + "px";
      floating.style.top = initialY + dy + "px";
    },
    { passive: false }
  );

  document.addEventListener("touchend", function () {
    if (!dragging) return;
    dragging = false;
    snapToNearestEdge();
  });
});